var _rect, _g, _circle, _circle2, _text, _text2, _text3, _text4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKcNextGen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 200",
    width: 350,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 200,
    rx: 24,
    fill: "#2c2c6c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4db5ff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 140,
    height: 120,
    rx: 10,
    fill: "#1f1f38"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 62,
    x2: 180,
    y2: 62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 76,
    width: 30,
    height: 72,
    rx: 4,
    fill: "rgba(77,181,255,0.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 76,
    width: 74,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 118,
    width: 34,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 118,
    width: 34,
    height: 30,
    rx: 4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 51,
    r: 3,
    fill: "#4db5ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 51,
    r: 3,
    fill: "#4db5ff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 95,
    fontFamily: "Poppins, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#ffffff"
  }, "Next-Gen")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 120,
    fontFamily: "Poppins, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#ffffff"
  }, "Platform")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 142,
    fontFamily: "Poppins, sans-serif",
    fontSize: 12,
    fill: "rgba(255,255,255,0.6)"
  }, "Library &amp; Courses")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 160,
    fontFamily: "Poppins, sans-serif",
    fontSize: 12,
    fill: "rgba(255,255,255,0.6)"
  }, "ground-up rebuild")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcNextGen);
export default __webpack_public_path__ + "static/media/KcNextGen.aadb3830209b086db4e7ce5e19c061b7.svg";
export { ForwardRef as ReactComponent };